import { useEffect, RefObject } from 'react';

interface ObserverOptions {
  threshold?: number | number[];
}

const useIntersectionObserver = (
  callback: IntersectionObserverCallback,
  targetRef: RefObject<Element>,
  options?: ObserverOptions,
): void => {
  useEffect(() => {
    const observer = new IntersectionObserver(callback, options);

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, [callback, options, targetRef]);
};

export default useIntersectionObserver;
